import { render, staticRenderFns } from "./SociosView.vue?vue&type=template&id=4c9f389c&scoped=true&"
import script from "./SociosView.vue?vue&type=script&lang=ts&"
export * from "./SociosView.vue?vue&type=script&lang=ts&"
import style0 from "./SociosView.vue?vue&type=style&index=0&id=4c9f389c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c9f389c",
  null
  
)

export default component.exports